
import Vue from 'vue';
import App from './App.vue';

import VueProgressBar from 'vue-progressbar';
import Toasted from 'vue-toasted';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

import router from './core/router';
import store from './store/index';
import http from './core/http';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'material-design-icons/iconfont/material-icons.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
// import './assets/fontAwesome/faall.css';
// import './assets/fontAwesome/fasolid.css';
import './assets/bootstrap.custom.min.css';
import './assets/custom.css';
import VModal from 'vue-js-modal';
import './core/globalMixin';
import './core/filter';
import './core/icons';

import Clipboard from 'v-clipboard';
Vue.use(Clipboard);

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import VueSocketIO from 'vue-socket.io';
let options = {
  path: '/api/socket.io',
  transports: ['websocket', 'polling', 'flashsocket'],
};

import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

Vue.use(new VueSocketIO({
  debug: false,
  connection: process.env.VUE_APP_SOCKET,
  options: process.env.VUE_APP_SOCKET === 'http://localhost:9191' ? {} : options, // pra funcionar localhost e na prod
}));

//THE MASK
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

const VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -100,
  force: true,
  cancelable: true,
});


library.add(fas);

// Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

Vue.use(BootstrapVue);

Vue.prototype.$http = http;

Vue.config.productionTip = false;

Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dialog: true });

Vue.use(Toasted, {
  iconPack: 'material', // set your iconPack, defaults to material. material|fontawesome
  position: 'top-right',
  duration: 5000,
  // theme: 'primary',
  // theme: 'bubble',
  theme: 'outline',
  icon: {
    name: 'done',
    after: true, // this will append the icon to the end of content
  },
});

Vue.use(VueProgressBar, {
  color: 'purple',
  failedColor: 'red',
  height: '2px',
});

export default new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
